<template>
    <div class="booking-management parent-frame">
        <div class="booking-management-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'bookingManagement',
    data () {
        return {
        }
    }
}
</script>
<style lang="scss" scoped>
    .booking-management{
        position: relative;
        .booking-management-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px){
        .booking-management{
            .booking-management-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/BookingManagementPages/BookingManagement.vue